export const PARTNERS_ROUTE = 'partnerzy';
export const PARTNERS_CONFIRMATION_ROUTE = 'potwierdzenie';
export const BUSINESS_REGISTRATION_PAGE = 'zakladanie-konta';
